import { applyMiddleware, createStore, compose, combineReducers } from "redux";
import thunk from "redux-thunk";
import { loadState } from "../utils/loadState";
import { saveState } from "../utils/saveState";
import { reducers } from "./reducers/rootReducer";

export const store = createStore(
    reducers,
    compose(applyMiddleware(thunk),)
    // compose(applyMiddleware(thunk), window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__())
);
//
// store.subscribe(() => 
